import type { RefObject } from 'react';
import { useCallback, useRef, useState } from 'react';
import useEventListener from './useEventListener';

function useFullScreenChange(): boolean {
  const body = useRef(typeof window !== 'undefined' ? document : null);
  const [isFullScreen, setIsFullscreen] = useState(false);

  const handleFullScreenChange = useCallback(() => {
    setIsFullscreen(!!(body.current && body.current.fullscreenElement));
  }, [body]);

  useEventListener(
    'webkitfullscreenchange' as keyof HTMLElementEventMap,
    handleFullScreenChange,
    body as RefObject<HTMLElement | null>,
  );
  useEventListener(
    'fullscreenchange',
    handleFullScreenChange,
    body as RefObject<HTMLElement | null>,
  );

  return isFullScreen;
}

export default useFullScreenChange;
